module.exports = __webpack_public_path__ + "img/cover.7340280b.jpg";